<bdg-select-field
  label="UF"
  [provider]="ufProvider"
  [control]="ufForm"
  data-testid="select-uf"
  [idOption]="idForm + '-select-ufOption'"
></bdg-select-field>
